import { useRouter } from 'next/router';
import type { FunctionComponent, MouseEvent } from 'react';

import { Button } from '@/domains/core/tamagoshiv2/components/Button/Button';

import styles from './viewmorebutton.module.scss';

interface Props {
  text: string;
  path?: string;
  onClick?: () => void;
}

export const ViewMoreButton: FunctionComponent<Props> = ({
  text,
  path,
  onClick = () => null,
}) => {
  const router = useRouter();

  const onLinkClick = (event: MouseEvent): void => {
    event.preventDefault();
    onClick();
    if (path) {
      const route = `${router.asPath.split('#')[0]}${path}`;
      router.push(route, undefined, { scroll: false, shallow: true });
    }
  };

  return (
    <div className={styles.container}>
      <Button
        content={text}
        type="secondary"
        onClick={onLinkClick}
        className={styles.moreComments}
        data-testid="viewMoreLinkButton"
        size="L"
      />
    </div>
  );
};
